var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pMenu",
    class: _vm.isMobile && 'wap'
  }, _vm._l(_vm.menu, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "btn pMenu-item",
      class: item.path === _vm.selectMenu && 'active',
      on: {
        "click": function ($event) {
          return _vm.onMenu(item);
        }
      }
    }, [_vm.isMobile ? _c('svg-icon', {
      attrs: {
        "name": item.value
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(item.label) + " ")], 1);
  }), 0);
};
var staticRenderFns = [];
export { render, staticRenderFns };